import el from "@cypherpotato/el";
import { formatNumber } from "../ui/format";
import { getUniqueColor } from "../ui/unique-color";

export function SegmentBar({ segments, autosize }) {

    const total = segments.reduce((a, b) => a + b.value, 0);
    

    return el("div.segment-bar",
        ...segments.filter(s => s.value > 0).map(segment => el(".segment-bar-segment",
            el("label", segment.label, el("strong", formatNumber(segment.value))),
            el("div", {
                style: {
                    backgroundColor: segment.color || getUniqueColor(segment.label)
                }
            }),
            {
                style: {
                    width: autosize ? segment.value / total * 100 + "%" : segment.value + "%"
                }
            }
        ))
    );
}